<template>
  <Modal
    data-test="modal__container"
    class="dea-modal--no-footer"
    :visible="visible"
    @modalClose="$emit('close-modal')"
  >
    <template slot="title">Il sito del libro è riservato a {{ localUser }}</template>
    <template slot="content">
      <div class="dea-heading--light__xs">
        Il libro <span class="dea-heading--regular__ms">{{ bookTitle }}</span> è stato attivato per
        <span class="dea-heading--regular__ms">{{ localUser }}</span
        >. <br />Se prosegui accederai automaticamente al sito libro con il profilo di
        <span class="dea-heading--regular__ms">{{ localUser }}</span
        >.
      </div>
      <div class="dea-modal-buttons">
        <Buttons class="dea-button--medium dea-button--outline" @click="$emit('close-modal')"
          >Torna all'Area Personale</Buttons
        >
        <Buttons
          class="dea-button--large"
          data-test="modal__button--open-child-book"
          :disabled="disableButton"
          @click="sendEvent"
          >Vai al sito del libro come {{ localUser }}</Buttons
        >
      </div>
    </template>
    <template slot="footer"></template>
  </Modal>
</template>

<script>
import Buttons from "@/components/elements/Buttons";
import Modal from "@/components/patterns/Modal";

export default {
  name: "ChildrenModal",
  components: { Modal, Buttons },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      required: true,
    },
    localUser: {
      type: String,
      required: true,
    },
    bookTitle: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      disableButton: false,
    };
  },
  methods: {
    sendEvent() {
      document.querySelector("body").classList.add("wait");
      this.disableButton = true;
      this.$emit("confirm-open-child-book");
    },
  },
};
</script>

<style lang="scss">
@import "~deascuola-storybook/src/styles/system.utils";

.wait .dea-button {
  cursor: wait !important; //sass-lint:disable-line no-important
}
</style>
